import React from 'react';
import { handleAuthError } from 'src/services/errorHandler';
import { authErrors } from 'src/constants/errorMessages';
import { Button } from 'src/components/ui/Button';
import { AlertCircle } from 'lucide-react';

interface AuthErrorHandlerProps {
  message: string;
  onRetry?: () => void;
}

const AuthErrorHandler: React.FC<AuthErrorHandlerProps> = ({ 
  message, 
  onRetry 
}) => {
  // Process the error message using our error handler service
  const formattedMessage = handleAuthError(message);

  return (
    <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg shadow-sm">
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <AlertCircle className="h-5 w-5 text-red-500" />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-red-800">
            Authentication Error
          </h3>
          <div className="mt-2 text-sm text-red-700">
            <p>{formattedMessage}</p>
          </div>
          {onRetry && (
            <div className="mt-4">
              <Button 
                variant="outline" 
                size="sm" 
                onClick={onRetry}
                className="text-red-600 hover:bg-red-100"
              >
                Try Again
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthErrorHandler;
